import { Progress } from './src/Progress'
export { Progress }
export default Progress



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Progress/index.ts